module.exports = __webpack_public_path__ + "images/feature/20160720_4-956ea21a09b79361a1800cd91feb9f40.jpg";